import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Common function to export data to Excel
 * @param {Array} data - The array of objects to export
 * @param {Array} headers - Array of objects containing { label: string, key: string }
 * @param {string} fileName - The name of the file to be saved (without extension)
 */
export const exportToExcel = (data, headers, fileName = "ExportedData") => {
  if (!data || data.length === 0) {
    console.error("No data available to export");
    return;
  }

  // 1. Prepare data for Excel
  const excelData = data.map((row) => {
    const formattedRow = {};
    headers.forEach((header) => {
      const keys = header.key.split('.');
      let value = row;
      
      for (const k of keys) {
        if (value && Object.prototype.hasOwnProperty.call(value, k)) {
          value = value[k];
        } else {
          value = null;
          break;
        }
      }
      
      formattedRow[header.label] = (value !== null && value !== undefined) ? value : "-";
    });
    return formattedRow;
  });

  // 2. Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // 3. Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 4. Generate buffer and save the file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const finalData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(finalData, `${fileName}_${new Date().getTime()}.xlsx`);
};
